'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VMessages = undefined;

var _VMessages = require('./VMessages');

var _VMessages2 = _interopRequireDefault(_VMessages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.VMessages = _VMessages2.default;
exports.default = _VMessages2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VMessages/index.js
// module id = 518
// module chunks = 0